import NetworkService from "../../services/network-service";

export default class OngoingWebinarMagnet {
    constructor() {
        this.$placeholder = document.getElementById('ongoing-webinar-magnet-placeholder');

        if (this.$placeholder) {
            this.init();
        }
    }

    init() {
        NetworkService.get(`${NetworkService.apiSiteUrl}/feed/teens/webinar-magnet`)
            .then((response) => {
                if (!response && !response.trim()) {
                    return;
                }

                this.$placeholder.insertAdjacentHTML('afterend', response.trim());
                this.$placeholder.remove();

                this.$root = document.querySelector('.ongoing-webinar-magnet');
                this.$close = this.$root.querySelector('.btn.-close');

                setTimeout(() => {
                    this.$root.classList.add('-show');
                }, 2500);

                this.$close.addEventListener('click', () => {
                    this.$root.classList.remove('-show');
                });
            });
    }
}